import { MakerListItem } from "@/model/MakerListItem.ts";

/**
 * 제조사 리스트 조회 - res
 */
export class ReadMakerListResDto {
    content: MakerListItem[];
}
